import { ChangeDetectionStrategy, Component } from '@angular/core';
import {My7nUiModule} from "@my7n/ui";
import {MatButton} from "@angular/material/button";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'availability-confirmation',
  imports: [
    My7nUiModule,
    MatButton
  ],
  templateUrl: './availability-confirmation.component.html',
  styleUrl: './availability-confirmation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityConfirmationComponent {

}
